const currency = 'USD';
const style = 'currency';

export default function formatCentsAsDollars(cents: number): string {
  const dollars = cents / 100;
  return new Intl.NumberFormat('en-US', { style, currency }).format(dollars);
}
